module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "successscreen"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ps-header"
  }, [_vm._v("Payment Successful")]), _vm._v(" "), _c('div', {
    staticClass: "ps-subheader"
  }, [_vm._v("Payment Receipt")]), _vm._v(" "), _c('ul', {
    staticClass: "receipt"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._l((_vm.bookingData), function(value, key) {
    return _c('li', {
      key: key
    }, [_c('div', {
      staticClass: "pr-left"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "pr-right"
    }, [_vm._v(_vm._s(value.name || value))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ps-info"
  }, [_vm._v("\n      Your payment has been successful, please keep this receipt for your records.\n      A copy has been sent to your email.\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panelheader border-blue"
  }, [_c('div', {
    staticClass: "booker-title"
  }, [_vm._v("Success")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-tick"
  }, [_c('i', {
    staticClass: "el-icon-fa-check-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "pr-left"
  }, [_vm._v("Transaction ID")]), _vm._v(" "), _c('div', {
    staticClass: "pr-right"
  }, [_vm._v("uY3Rpb24gcmF")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "pr-left"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('div', {
    staticClass: "pr-right"
  }, [_vm._v("$50.00")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b30318","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booker/SuccessScreen.vue
// module id = 886
// module chunks = 2